import service from "@/store/services/taxes-service";

export const state = () => ({
  list: {},
  contacts: {},
  tax: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, tax) => {
    state.tax = tax;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_CONTACTS: (state, contacts) => {
    state.contacts = contacts;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((tax) => {
      commit("SET_RESOURCE", tax);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((tax) => {
      commit("SET_RESOURCE", tax);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((tax) => {
      commit("SET_RESOURCE", tax);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  tax: (state) => state.tax,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((tax) => ({
      id: tax.id,
      name: `${tax.name}`,
    }));
  },
};

const taxes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default taxes;
